module.exports = __webpack_public_path__ + "img/branco.ebca466b.png";